import React from 'react'
import { Button, GlassMorphIcon } from '@/components/ui'
import type { IFinancingUxFeedbackModalAlertProps } from './types'
import './styles.scss'

export const FinancingUxFeedbackModalAlert = (props: IFinancingUxFeedbackModalAlertProps) => {
  const { icon, title, actionMessage, onActions } = props

  return (
    <div className="financingUxFeedbackModalAlert">
      {icon && <GlassMorphIcon image={icon} className="financingUxFeedbackModalAlert__icon" />}

      <h4 className="financingUxFeedbackModalAlert__title">{title}</h4>
      <Button type="button" modifiers={['green', 'full-width-mobile']} onClick={onActions}>
        {actionMessage}
      </Button>
    </div>
  )
}
